"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_state_1 = require("prosemirror-state");
var prosemirror_view_1 = require("prosemirror-view");
var DECO_TYPE = {
    ADD: 'add',
    REMOVE: 'remove',
    APPEND_NODE: 'appendNode',
    APPEND_INLINE: 'appendInline'
};
exports.DECO_TYPE = DECO_TYPE;
var DecoKey = new prosemirror_state_1.PluginKey('decoration');
exports.DecoKey = DecoKey;
var DecorationPlugin = function () {
    return new prosemirror_state_1.Plugin({
        key: DecoKey,
        state: {
            init: function () {
                return prosemirror_view_1.DecorationSet.empty;
            },
            apply: function (tr, set) {
                var newSet = set;
                var decoState = tr.getMeta(DecoKey);
                if (decoState && decoState.action) {
                    var findItem = function () {
                        return newSet.find(undefined, undefined, function (_a) {
                            var key = _a.key;
                            return key === decoState.data.spec.key;
                        });
                    };
                    var targetItems_1 = findItem();
                    switch (decoState.action) {
                        case DECO_TYPE.ADD: {
                            if (targetItems_1.length)
                                break;
                            var _a = decoState.data, pos = _a.pos, shadow_1 = _a.shadow, spec = _a.spec;
                            newSet = newSet.add(tr.doc, [
                                prosemirror_view_1.Decoration.widget(pos, function (view, getPos) { return shadow_1(decoState.dom, view, getPos); }, spec)
                            ]);
                            break;
                        }
                        case DECO_TYPE.REMOVE: {
                            var times = 0;
                            var removeItem = function () {
                                targetItems_1.forEach(function (target) {
                                    target.spec.onRemove && target.spec.onRemove();
                                });
                                newSet = newSet.remove(targetItems_1);
                            };
                            while (targetItems_1.length && times < 3) {
                                targetItems_1[0].from = targetItems_1[0].from - times;
                                targetItems_1[0].to = targetItems_1[0].to - times;
                                removeItem();
                                targetItems_1 = findItem();
                                times++;
                            }
                            break;
                        }
                        case DECO_TYPE.APPEND_NODE: {
                            if (targetItems_1.length)
                                break;
                            var _b = decoState.data, from = _b.from, to = _b.to, attrs = _b.attrs, spec = _b.spec;
                            newSet = newSet.add(tr.doc, [
                                prosemirror_view_1.Decoration.node(from, to, attrs, spec)
                            ]);
                            break;
                        }
                        case DECO_TYPE.APPEND_INLINE: {
                            if (targetItems_1.length)
                                break;
                            var _c = decoState.data, from = _c.from, to = _c.to, attrs = _c.attrs, spec = _c.spec;
                            newSet = newSet.add(tr.doc, [
                                prosemirror_view_1.Decoration.inline(from, to, attrs, spec)
                            ]);
                        }
                    }
                    return newSet;
                }
                else {
                    return newSet.map(tr.mapping, tr.doc, {
                        onRemove: function (spec) { return spec.onRemove && spec.onRemove(); }
                    });
                }
            }
        },
        appendTransaction: function (trs, oldState, newState) {
            var tr = newState.tr;
            var newDecorations = DecoKey.getState(newState).find();
            var oldDecorations = DecoKey.getState(oldState).find();
            if (newDecorations.length < oldDecorations.length) {
                oldDecorations.some(function (decoration) {
                    if (decoration.from < tr.doc.nodeSize &&
                        newDecorations.every(function (_a) {
                            var spec = _a.spec;
                            return spec.key !== decoration.spec.key;
                        })) {
                        var $pos = tr.doc.resolve(decoration.from);
                        var from = $pos.pos;
                        var to = $pos.pos;
                        var zeroBefore = null;
                        var zeroAfter = null;
                        $pos.nodeBefore &&
                            (zeroBefore = $pos.nodeBefore.textContent.match(/\u200B$/));
                        $pos.nodeAfter &&
                            (zeroAfter = $pos.nodeAfter.textContent.match(/^\u200B/));
                        zeroBefore && (from -= zeroBefore.length);
                        zeroAfter && (to += zeroAfter.length);
                        tr = tr.delete(from, to);
                        return true;
                    }
                    else {
                        return false;
                    }
                });
                return tr;
            }
            else {
                return null;
            }
        },
        props: {
            decorations: function (state) {
                return this.getState(state);
            }
        }
    });
};
exports.DecorationPlugin = DecorationPlugin;
//# sourceMappingURL=index.js.map